/*eslint angular/file-name: 0*/
(function() {
    'use strict';
    angular.module('emarket.main.post', [ 'ui.router' ]).config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('main.offers', {
                url: '/ofertas',
                views: {
                    main: {
                        controller: 'PostSearchController as model',
                        templateUrl: 'main/post/search/search.tpl.html'
                    }
                },
                reloadOnSearch: false,
                params: {
                    isPremium: true
                },

                resolve: {
                    provinces: ['Province', function(Province) {
                        return Province.$search().$asPromise();
                    }],
                    categories: ['Category', function categories(Category) {
                        return Category.$search().$asPromise();
                    }],
                    currencies: ['Currency', function currencies(Currency) {
                        return Currency.$search().$asPromise();
                    }]
                }
            })
            .state('main.post', {
                url: '/producto',
                abstract: true,
                views: {
                    main: {
                        template:
              '<ui-view name="post" autoscroll="false" class="post" layout="column" flex></ui-view>'
                    }
                }
            })
            .state('main.post.search', {
                url: '/buscar?q?categoria?provincia?usuario?premium',
                views: {
                    post: {
                        controller: 'PostSearchController as model',
                        templateUrl: 'main/post/search/search.tpl.html'
                    }
                },
                reloadOnSearch: false,
                resolve: {
                    provinces: ['Province', function(Province) {
                        return Province.$search().$asPromise();
                    }],
                    categories: ['Category', function categories(Category) {
                        return Category.$search().$asPromise();
                    }],
                    currencies: ['Currency', function currencies(Currency) {
                        return Currency.$search().$asPromise();
                    }]
                }
            })
            .state('main.post.search.detail', {
                url: '/detalle/:title',
                onEnter: ['$log', '$state', '$stateParams', function($log, $state, $stateParams) {
                    //if load directive go to main.post.detail
                    if (!$state.previous) {
                        $state.go('main.post.detail', { title: $stateParams.title }, { location: 'replace' });
                    }
                }]
            })
            .state('main.post.search.detail-desktop', {
                url: '/detalles/:title',
                views: {
                    detail: {
                        templateUrl: 'main/post/detail/detail.tpl.html',
                        controller: 'PostDetailController as model'
                    }
                },
                params: {
                    post: null,
                    showNavBar: true
                },
                resolve: {
                    post: ['$stateParams', '$q', 'Post', function($stateParams, $q, Post) {
                        // if($stateParams.post) {
                        //     return $q.when($stateParams.post);
                        // } else {
                        return Post.$find($stateParams.title).$asPromise();
                        // }
                    }]
                },
                onEnter: ['$state', '$stateParams', function($state, $stateParams) {
                    //if load directive go to main.post.detail
                    if (!$state.previous) {
                        $state.go('main.post.detail', { title: $stateParams.title }, { location: 'replace' });
                    }
                }]
            })
            .state('main.post.success', {
                url: '/creado/:id',
                views: {
                    post: {
                        templateUrl: 'main/post/create/success.tpl.html',
                        controller: 'PostSuccessController as model'
                    }
                }
            })
            .state('main.post.create', {
                url: '/crear',
                views: {
                    post: {
                        controller: 'PostCreateController as model',
                        templateProvider: ['$templateCache', '$mdMedia', function($templateCache, $mdMedia) {
                            var template = 'main/post/create/create-mobile.tpl.html';
                            if ($mdMedia('gt-sm')) {
                                template = 'main/post/create/create-desktop.tpl.html';
                            }
                            return $templateCache.get(template);
                        }]
                        // templateUrl: function($mdMedia, $log) {
                        //     $log.info($mdMedia('xs'));
                        //     return 'main/post/create/create.tpl.html';
                        // }
                    }
                },
                resolve: {
                    currencies: ['Currency', function(Currency) {
                        return Currency.$search().$asPromise();
                    }],
                    provinces: ['Province', function(Province) {
                        return Province.$search().$asPromise();
                    }]
                },
                params: {
                    grabar: false
                },
                data: {
                    hideFabAction: true,
                    hideFabActionMobile: true,
                    hideBanner: '728x90',
                    hideNavigationMenu: true,
                    showBackButton: true
                }
            })
            .state('main.post.edit', {
                url: '/editar/:id',
                views: {
                    post: {
                        controller: 'PostCreateController as model',
                        templateProvider: ['$templateCache', '$mdMedia', function($templateCache, $mdMedia) {
                            var template = 'main/post/create/create-mobile.tpl.html';
                            if ($mdMedia('gt-sm')) {
                                template = 'main/post/create/create-desktop.tpl.html';
                            }
                            return $templateCache.get(template);
                        }]
                    }
                },
                resolve: {
                    isLogin: ['Auth', function(Auth) {
                        return Auth.requiredAuthentication();
                    }],
                    currencies: ['Currency', function(Currency) {
                        return Currency.$search().$asPromise();
                    }],
                    provinces: ['Province', function(Province) {
                        return Province.$search().$asPromise();
                    }]
                },
                data: {
                    hideFabAction: true,
                    hideBanner: '728x90',
                    showBackButton: true
                }
            })
            .state('main.post.detail', {
                url: '/detalles/:title',
                views: {
                    post: {
                        controller: 'PostDetailController as model',
                        templateUrl: 'main/post/detail/detail.tpl.html'
                    }
                },
                resolve: {
                    post: ['$stateParams', 'Post', function($stateParams, Post) {
                        var id = $stateParams.title;
                        return Post.$find(id).$asPromise();
                    }]
                },
                data: {
                    hideFabActionMobile: true,
                    hideBanner: '728x90',
                    showBackButton: true
                }
            });
    }]);
}());

/*eslint angular/file-name: 0*/
(function() {
    'use strict';
    angular.module('emarket.main.post', [ 'ui.router' ]).config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('main.offers', {
                url: '/ofertas',
                views: {
                    main: {
                        controller: 'PostSearchController as model',
                        templateUrl: 'main/post/search/search.tpl.html'
                    }
                },
                reloadOnSearch: false,
                params: {
                    isPremium: true
                },

                resolve: {
                    provinces: ['Province', function(Province) {
                        return Province.$search().$asPromise();
                    }],
                    categories: ['Category', function categories(Category) {
                        return Category.$search().$asPromise();
                    }],
                    currencies: ['Currency', function currencies(Currency) {
                        return Currency.$search().$asPromise();
                    }]
                }
            })
            .state('main.post', {
                url: '/producto',
                abstract: true,
                views: {
                    main: {
                        template:
              '<ui-view name="post" autoscroll="false" class="post" layout="column" flex></ui-view>'
                    }
                }
            })
            .state('main.post.search', {
                url: '/buscar?q?categoria?provincia?usuario?premium',
                views: {
                    post: {
                        controller: 'PostSearchController as model',
                        templateUrl: 'main/post/search/search.tpl.html'
                    }
                },
                reloadOnSearch: false,
                resolve: {
                    provinces: ['Province', function(Province) {
                        return Province.$search().$asPromise();
                    }],
                    categories: ['Category', function categories(Category) {
                        return Category.$search().$asPromise();
                    }],
                    currencies: ['Currency', function currencies(Currency) {
                        return Currency.$search().$asPromise();
                    }]
                }
            })
            .state('main.post.search.detail', {
                url: '/detalle/:title',
                onEnter: ['$log', '$state', '$stateParams', function($log, $state, $stateParams) {
                    //if load directive go to main.post.detail
                    if (!$state.previous) {
                        $state.go('main.post.detail', { title: $stateParams.title }, { location: 'replace' });
                    }
                }]
            })
            .state('main.post.search.detail-desktop', {
                url: '/detalles/:title',
                views: {
                    detail: {
                        templateUrl: 'main/post/detail/detail.tpl.html',
                        controller: 'PostDetailController as model'
                    }
                },
                params: {
                    post: null,
                    showNavBar: true
                },
                resolve: {
                    post: ['$stateParams', '$q', 'Post', function($stateParams, $q, Post) {
                        // if($stateParams.post) {
                        //     return $q.when($stateParams.post);
                        // } else {
                        return Post.$find($stateParams.title).$asPromise();
                        // }
                    }]
                },
                onEnter: ['$state', '$stateParams', function($state, $stateParams) {
                    //if load directive go to main.post.detail
                    if (!$state.previous) {
                        $state.go('main.post.detail', { title: $stateParams.title }, { location: 'replace' });
                    }
                }]
            })
            .state('main.post.success', {
                url: '/creado/:id',
                views: {
                    post: {
                        templateUrl: 'main/post/create/success.tpl.html',
                        controller: 'PostSuccessController as model'
                    }
                }
            })
            .state('main.post.create', {
                url: '/crear',
                views: {
                    post: {
                        controller: 'PostCreateController as model',
                        templateProvider: ['$templateCache', '$mdMedia', function($templateCache, $mdMedia) {
                            var template = 'main/post/create/create-mobile.tpl.html';
                            if ($mdMedia('gt-sm')) {
                                template = 'main/post/create/create-desktop.tpl.html';
                            }
                            return $templateCache.get(template);
                        }]
                        // templateUrl: function($mdMedia, $log) {
                        //     $log.info($mdMedia('xs'));
                        //     return 'main/post/create/create.tpl.html';
                        // }
                    }
                },
                resolve: {
                    currencies: ['Currency', function(Currency) {
                        return Currency.$search().$asPromise();
                    }],
                    provinces: ['Province', function(Province) {
                        return Province.$search().$asPromise();
                    }]
                },
                params: {
                    grabar: false
                },
                data: {
                    hideFabAction: true,
                    hideFabActionMobile: true,
                    hideBanner: '728x90',
                    hideNavigationMenu: true,
                    showBackButton: true
                }
            })
            .state('main.post.edit', {
                url: '/editar/:id',
                views: {
                    post: {
                        controller: 'PostCreateController as model',
                        templateProvider: ['$templateCache', '$mdMedia', function($templateCache, $mdMedia) {
                            var template = 'main/post/create/create-mobile.tpl.html';
                            if ($mdMedia('gt-sm')) {
                                template = 'main/post/create/create-desktop.tpl.html';
                            }
                            return $templateCache.get(template);
                        }]
                    }
                },
                resolve: {
                    isLogin: ['Auth', function(Auth) {
                        return Auth.requiredAuthentication();
                    }],
                    currencies: ['Currency', function(Currency) {
                        return Currency.$search().$asPromise();
                    }],
                    provinces: ['Province', function(Province) {
                        return Province.$search().$asPromise();
                    }]
                },
                data: {
                    hideFabAction: true,
                    hideBanner: '728x90',
                    showBackButton: true
                }
            })
            .state('main.post.detail', {
                url: '/detalles/:title',
                views: {
                    post: {
                        controller: 'PostDetailController as model',
                        templateUrl: 'main/post/detail/detail.tpl.html'
                    }
                },
                resolve: {
                    post: ['$stateParams', 'Post', function($stateParams, Post) {
                        var id = $stateParams.title;
                        return Post.$find(id).$asPromise();
                    }]
                },
                data: {
                    hideFabActionMobile: true,
                    hideBanner: '728x90',
                    showBackButton: true
                }
            });
    }]);
}());
